import { render, staticRenderFns } from "./BranchOrders.vue?vue&type=template&id=3767428e&scoped=true&"
import script from "./BranchOrders.vue?vue&type=script&lang=js&"
export * from "./BranchOrders.vue?vue&type=script&lang=js&"
import style0 from "./BranchOrders.vue?vue&type=style&index=0&id=3767428e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3767428e",
  null
  
)

export default component.exports